import React, { Component } from 'react';
import { Row, Col, Select, Table, Cascader, Popover, Button, Tag } from 'antd';
import { api, app } from "../../app";
import utils from "../../utils";

const Option = Select.Option;

class Filter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            token: '',
            classList: [],
            screenList: [],
            dataList: [],
            data_loading: false,
        };
    }

    componentDidMount() {
        this._isMounted = true;
        this.getTokeni();
        this.handleToolLoading();
        this.dataSouces();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }


    handleToolLoading = () => {
        const _this = this;
        //技能列表
        app.post(api.HomeClassList).then(({ flag, data, msg }) => {
            if (_this._isMounted) {
                if (flag === 1) {
                    _this.setState({ classList: data });
                } else {
                    app.alert(msg, "warn");
                }
            }
        })
        //课程列表
        app.post(api.TrainScreen).then(({ flag, data, msg }) => {
            if (_this._isMounted) {
                if (flag === 1) {
                    const screenList = data.map((screen) => {
                        const obj = {
                            value: screen.class_id,
                            label: screen.names,
                            disabled: screen.train.length > 0 ? false : true,
                            children: screen.train.map((train) => {
                                return {
                                    value: train.trainame + ',' + train.train_id,
                                    label: train.trainame,
                                }
                            })
                        };
                        return obj;
                    });
                    _this.setState({ screenList });
                } else {
                    app.alert(msg, "warn");
                }
            }
        })
        //省份列表
        app.post(api.ProvinceList).then(({ flag, data, msg }) => {
            if (_this._isMounted) {
                if (flag === 1) {
                    _this.setState({ provinceList: data });
                } else {
                    app.alert(msg, "error");
                }
            }
        })
    }

    /**
     * 数据
     * @returns {boolean}
     */
    dataSouces = () => {
        this.setState({ data_loading: true }, () => {
            const _this = this, params = {
                indexno: app.getData('indexno'),
                account: app.getData('account'),
                province: this.state.filter_province,
                ppe: this.state.filter_class,
                trainame: this.state.filter_screen,
            };
            app.post(api.UserScreen, params).then(({ flag, data, msg }) => {
                if (_this._isMounted) {
                    _this.setState({ data_loading: false });
                    if (flag === 1) {
                        _this.setState({ dataList: utils.addArrayKey(data) });
                    } else {
                        app.alert(msg, "warn");
                    }
                }
            })
        });
    }

    /**
     * 技能筛选
     * @param value
     */
    handleClassChange = (value) => {
        const filter_class = value || "";
        this.setState({ filter_class });
    }

    /**
    * 获取token
    * @returns {Promise<void>}
    */
    getTokeni = async () => {
        let { flag, data, msg } = await app.post(api.getToken);
        if (flag === 1) {
            this.setState({
                token: data.token
            });
        } else {
            app.alert(msg, 'warn');
        }
    };

    /**
     * 课程筛选
     * @param value
     */
    handleScreenChange = (value) => {
        const filter_screen = value.length > 0 ? value[1].split(',')[0] : '';
        this.setState({ filter_screen });
    }

    /**
     * 省份筛选
     * @param value
     */
    handleProvinceChange = (value) => {
        const filter_province = value || "";
        this.setState({ filter_province });
    }

    handleFilter = () => {
        this.dataSouces();
    }

    handleRowClick = (record) => {
        this.props.history.push(`/player/${record.team_id}/${record.indexno}?token=${this.state.token}`);
    }

    render() {
        const columns = [
            {
                title: '顺序号',
                dataIndex: '',
                key: 'sxh',
                width: '10%',
                render(text, record, index) {
                    return index + 1;
                }
            },
            {
                title: '姓名',
                dataIndex: 'vname',
                key: 'vname',
                width: '10%'
            },
            {
                title: '省份',
                dataIndex: 'province',
                key: 'province',
                width: '10%'
            },
            {
                title: '所属队伍',
                dataIndex: 'teamname',
                key: 'teamname',
                width: '15%'
            },
            {
                title: '存心编号',
                dataIndex: 'bsrno',
                key: 'bsrno',
                width: '10%'
            },
            {
                title: '救援经历',
                dataIndex: 'rescue_count',
                key: 'rescue_count',
                width: '10%'
            },
            {
                title: '拥有技能',
                dataIndex: 'ppe',
                key: 'ppe',
                width: '25%',
                render(text) {
                    return text || '暂无';
                }
            },
            {
                title: '培训课程',
                dataIndex: 'train',
                key: 'train',
                width: '10%',
                render(text) {
                    return (
                        <Popover content={
                            <div className="train-popover">
                                {
                                    text.length > 0 ?
                                        text.map((train, index) => {
                                            return (
                                                <p key={index + 1}>{train}</p>
                                            );
                                        }) :
                                        (<p>暂无培训课程</p>)
                                }
                            </div>
                        }>
                            <Tag>所有培训过的课程</Tag>
                        </Popover>
                    )
                }
            }
        ],
            loading = this.state.data_loading,
            classList = this.state.classList,
            screenList = this.state.screenList,
            dataList = this.state.dataList,
            provinceList = this.state.provinceList || [],
            locale = {
                filterTitle: '筛选',
                filterConfirm: '确定',
                filterReset: '重置',
                emptyText: loading ? '正在加载中...' : '暂无数据',
            };

        return (
            <div className="ranks_filter">
                <div className="f_title">技能筛选</div>
                <Row className="tools" gutter={20}>
                    <Col span={6}>
                        <Select
                            allowClear
                            showSearch
                            style={{ width: '100%' }}
                            placeholder="筛选技能"
                            optionFilterProp="children"
                            onChange={this.handleClassChange}
                        >
                            {
                                classList.map((cla, index) => {
                                    return (
                                        <Option key={index + 1} value={cla.names}>{cla.names}</Option>
                                    );
                                })
                            }
                        </Select>
                    </Col>
                    <Col span={6}>
                        <Cascader
                            options={screenList}
                            style={{ width: '100%' }}
                            placeholder="筛选课程"
                            onChange={this.handleScreenChange}
                            displayRender={(label) => {
                                return label[label.length - 1]
                            }}

                        />
                    </Col>
                    <Col span={6}>
                        <Select
                            allowClear
                            showSearch
                            style={{ width: '100%' }}
                            placeholder="筛选省份"
                            optionFilterProp="children"
                            onChange={this.handleProvinceChange}
                        >
                            {
                                provinceList.map((pro, index) => {
                                    return (
                                        <Option key={index + 1} value={pro.area_name}>{pro.area_name}</Option>
                                    );
                                })
                            }
                        </Select>
                    </Col>
                    <Col span={6}>
                        <Button onClick={() => this.handleFilter()}>筛选队伍</Button>
                    </Col>
                </Row>
                <Table className="ranks_table" scroll={{ x: true, y: 600 }} size="middle" locale={locale}
                    columns={columns}
                    dataSource={dataList}
                    onRow={(record) => {
                        return {
                            onClick: () => this.handleRowClick(record)
                        }
                    }}
                    loading={loading}
                    pagination={false} />
            </div>
        );
    }
}

export default Filter;



// WEBPACK FOOTER //
// ./src/routes/ranks/Filter.jsx